import ApiService from './api.service'
import { TokenService } from './storage.service'
import {CurrentUser} from "@/pitprojekt/models/CurrentUser";
import {  deserialize } from 'serializr';
import { AuthenticationError } from './responses/AuthenticationError';
import { Error } from './responses/Error';
import { Success } from "@/services/responses/Success";

const UserService = {

    /**
     * Login the user and store the access token to TokenService.
     * @param email string
     * @param password string
     *
     * @returns access_token
     * @throws AuthenticationError
     **/
    login: async function(email: string, password: string) {

        try {
            const response = await ApiService.post('/api/login', {email: email, password: password});

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader();

            return response.data.access_token;
        } catch (error) {
            throw new AuthenticationError(error.response.data.message, error.response.status);
        }
    },

    /**
     * Refresh the access token.
     **/
    refreshToken: async function() {
        const refreshToken = TokenService.getRefreshToken()

        const requestData = {
            method: 'post',
            url: "/o/token/",
            data: {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader()

            return response.data.access_token
        } catch (error) {
            throw new Error(error.response.data.message, error.response.status)
        }

    },

    /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
     **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()
        Success.showSnackbar('Wylogowano poprawnie.')
    },


    getCurrentUser: async function() {

        try {
            const response = await ApiService.get('/api/current-user');
            const currentUser:CurrentUser = deserialize(CurrentUser, response.data);
            return currentUser;

        } catch (error) {
            throw new Error(error.response.data.message, error.response.status)
        }
    },


    /**
     * Change current user password
     *
     * @param oldPassword string
     * @param newPassword string
     * @param newPasswordConfirm string
     *
     * @returns access_token
     **/
    changePassword: async function(oldPassword: string, newPassword: string, newPasswordConfirm: string) {
        try {
            const response = await ApiService.post('/api/change-password', {'oldPassword': oldPassword, 'newPassword': newPassword, 'newPasswordConfirm': newPasswordConfirm});
            Success.showSnackbar('Hasło zostało zmienione.')
            return response.data;
        } catch (error) {
            throw new Error(error.response.data.message, error.response.status, (error.response.data.errors != undefined) ? error.response.data.errors : [])
        }
    },


}

export default UserService

export { UserService }
